import React, { FC } from "react";
import { Analytics } from "../../features/analytics";

const AnalyticsPage: FC = () => {
  return <Analytics />;
};

export default AnalyticsPage;
